<template>
  <div class="space-actions-cell">
    <Button class="square xs outline-white primary-hover" icon="bi-pencil" @click="onEdit"></Button>
  </div>
</template>

<script lang="ts" setup>
import Button from '@/components/global/Button.vue';

const props = defineProps({
  params: Object, // injected by AG Grid, contains `data`, `api`, etc.
});

function onEdit() {
  props.params.onEdit(props.params.data);
}
</script>

<style lang="scss">
.space-actions-cell {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 4px;
  height: 100%;
}

</style>